<template>
  <div class="homeContainer">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>设置</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="hideInAddShow = false">消息列表</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <section class="messageList" v-show="!hideIsSend">
      <!-- 面包屑 end   -->
      <a-button type="primary" @click="hideIsSend = true">发送消息</a-button>

      <!-- <h2>我的消息</h2> -->
      <table>
        <thead>
          <tr>
            <th>时间</th>
            <th>消息类型</th>
            <th>标题</th>
            <th>内容</th>
            <th>发送者</th>
          </tr>
        </thead>
        <tbody>
          <tr v-show="data.length > 0" v-for="item in data" :key="item.id">
            <td>{{ item.create_time.substring(0, 10) }}</td>
            <td>
              <span v-if="item.message_type == 1">工单消息</span>
              <span v-else-if="item.message_type == 2">物料消息</span>
              <span v-else-if="item.message_type == 3">公告消息</span>
              <!-- <span v-else-if="item.message_type==4">私发消息</span> -->
              <span v-else>系统消息</span>
            </td>
            <td>{{ item.title }}</td>
            <td style="width:50%">{{ item.content }}</td>
            <td>{{ item.send_user }}</td>
          </tr>
          <tr v-show="data == ''">
            <td></td>
            <td></td>
            <td>-- 暂无 --</td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- 发送消息 -->
    <send v-show="hideIsSend" v-on:hideInSend="hideInSend" />
    <!-- 发送消息 end-->
  </div>
</template>
<script>
import axios from "axios";
import send from "@/components/message/send"; //发送消息
export default {
  data() {
    return {
      loading: false,
      data: "",
      page: 1,
      pagination: {},
      hideIsSend: false
    };
  },
  mounted() {
    this.getData(); //获取数据
  },
  components: {
    send
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  methods: {
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    getData() {
      let url =
        this.httpsBasic.url + this.httpsBasic.message + "Message/queryMessage";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          page: this.page
        })
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            // console.log(this.data);
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          }
        });
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    hideInSend() {
      this.hideIsSend = false;
      this.reload();
    }
  }
};
</script>
<style lang="less" scoped>
.breadcrumb {
  padding: 14px 0 10px;
  border-bottom: 1px solid #f0f2f5;
}
.homeContainer {
  background: #fff;
  margin: 20px 2%;
  min-height: 80vh;
  padding: 14px 4%;
  .messageList {
    // width: 50%;
    > button {
      margin-top: 30px;
      margin-bottom: 20px;
    }
    h2 {
      font-size: 14px;
      font-weight: normal;
      margin-top: 10px;
      margin-bottom: 10px;
    }
    table {
      width: 100%;
      tr {
        font-size: 12px;
        border: 1px solid #ccc;
        th {
          background: #fafafa;
        }
        th,
        td {
          font-size: 14px;
          padding: 6px 8px;
          line-height: 20px;
        }
      }
    }
  }
}
</style>
